export default "__VITE_ASSET__6b2ae751__"